function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = [
    "field",
    "colDef"
];
import * as React from 'react';
import PropTypes from 'prop-types';
import composeClasses from '@mui/utils/composeClasses';
import { forwardRef } from '@mui/x-internals/forwardRef';
import { isMultipleRowSelectionEnabled } from "../../hooks/features/rowSelection/utils.js";
import { useGridSelector } from "../../hooks/utils/useGridSelector.js";
import { gridTabIndexColumnHeaderSelector } from "../../hooks/features/focus/gridFocusStateSelector.js";
import { gridRowSelectionStateSelector } from "../../hooks/features/rowSelection/gridRowSelectionSelector.js";
import { useGridApiContext } from "../../hooks/utils/useGridApiContext.js";
import { getDataGridUtilityClass } from "../../constants/gridClasses.js";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.js";
import { gridExpandedSortedRowIdsSelector } from "../../hooks/features/filter/gridFilterSelector.js";
import { gridPaginatedVisibleSortedGridRowIdsSelector } from "../../hooks/features/pagination/gridPaginationSelector.js";
import { jsx as _jsx } from "react/jsx-runtime";
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: [
            'checkboxInput'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
var GridHeaderCheckbox = forwardRef(function GridHeaderCheckbox(props, ref) {
    var _rootProps_slotProps;
    var other = _objectWithoutPropertiesLoose(props, _excluded);
    var _React_useState = _sliced_to_array(React.useState(false), 2), forceUpdate = _React_useState[1];
    var apiRef = useGridApiContext();
    var rootProps = useGridRootProps();
    var ownerState = {
        classes: rootProps.classes
    };
    var classes = useUtilityClasses(ownerState);
    var tabIndexState = useGridSelector(apiRef, gridTabIndexColumnHeaderSelector);
    var selection = useGridSelector(apiRef, gridRowSelectionStateSelector);
    var visibleRowIds = useGridSelector(apiRef, gridExpandedSortedRowIdsSelector);
    var paginatedVisibleRowIds = useGridSelector(apiRef, gridPaginatedVisibleSortedGridRowIdsSelector);
    var filteredSelection = React.useMemo(function() {
        if (typeof rootProps.isRowSelectable !== 'function') {
            return selection;
        }
        return selection.filter(function(id) {
            if (rootProps.keepNonExistentRowsSelected) {
                return true;
            }
            // The row might have been deleted
            if (!apiRef.current.getRow(id)) {
                return false;
            }
            return rootProps.isRowSelectable(apiRef.current.getRowParams(id));
        });
    }, [
        apiRef,
        rootProps.isRowSelectable,
        selection,
        rootProps.keepNonExistentRowsSelected
    ]);
    // All the rows that could be selected / unselected by toggling this checkbox
    var selectionCandidates = React.useMemo(function() {
        var rowIds = !rootProps.pagination || !rootProps.checkboxSelectionVisibleOnly || rootProps.paginationMode === 'server' ? visibleRowIds : paginatedVisibleRowIds;
        // Convert to an object to make O(1) checking if a row exists or not
        // TODO create selector that returns visibleRowIds/paginatedVisibleRowIds as an object
        return rowIds.reduce(function(acc, id) {
            acc[id] = true;
            return acc;
        }, {});
    }, [
        rootProps.pagination,
        rootProps.paginationMode,
        rootProps.checkboxSelectionVisibleOnly,
        paginatedVisibleRowIds,
        visibleRowIds
    ]);
    // Amount of rows selected and that are visible in the current page
    var currentSelectionSize = React.useMemo(function() {
        return filteredSelection.filter(function(id) {
            return selectionCandidates[id];
        }).length;
    }, [
        filteredSelection,
        selectionCandidates
    ]);
    var isIndeterminate = currentSelectionSize > 0 && currentSelectionSize < Object.keys(selectionCandidates).length;
    var isChecked = currentSelectionSize > 0;
    var handleChange = function(event) {
        var params = {
            value: event.target.checked
        };
        apiRef.current.publishEvent('headerSelectionCheckboxChange', params);
    };
    var tabIndex = tabIndexState !== null && tabIndexState.field === props.field ? 0 : -1;
    React.useLayoutEffect(function() {
        var element = apiRef.current.getColumnHeaderElement(props.field);
        if (tabIndex === 0 && element) {
            element.tabIndex = -1;
        }
    }, [
        tabIndex,
        apiRef,
        props.field
    ]);
    var handleKeyDown = React.useCallback(function(event) {
        if (event.key === ' ') {
            // imperative toggle the checkbox because Space is disable by some preventDefault
            apiRef.current.publishEvent('headerSelectionCheckboxChange', {
                value: !isChecked
            });
        }
    }, [
        apiRef,
        isChecked
    ]);
    var handleSelectionChange = React.useCallback(function() {
        forceUpdate(function(p) {
            return !p;
        });
    }, []);
    React.useEffect(function() {
        return apiRef.current.subscribeEvent('rowSelectionChange', handleSelectionChange);
    }, [
        apiRef,
        handleSelectionChange
    ]);
    var checked = rootProps.indeterminateCheckboxAction === 'select' ? isChecked && !isIndeterminate : isChecked;
    var label = apiRef.current.getLocaleText(checked ? 'checkboxSelectionUnselectAllRows' : 'checkboxSelectionSelectAllRows');
    return /*#__PURE__*/ _jsx(rootProps.slots.baseCheckbox, _extends({
        indeterminate: isIndeterminate,
        checked: checked,
        onChange: handleChange,
        className: classes.root,
        inputProps: {
            'aria-label': label,
            name: 'select_all_rows'
        },
        tabIndex: tabIndex,
        onKeyDown: handleKeyDown,
        disabled: !isMultipleRowSelectionEnabled(rootProps)
    }, (_rootProps_slotProps = rootProps.slotProps) === null || _rootProps_slotProps === void 0 ? void 0 : _rootProps_slotProps.baseCheckbox, other, {
        ref: ref
    }));
});
process.env.NODE_ENV !== "production" ? GridHeaderCheckbox.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * The column of the current header component.
   */ colDef: PropTypes.object.isRequired,
    /**
   * The column field of the column that triggered the event
   */ field: PropTypes.string.isRequired
} : void 0;
export { GridHeaderCheckbox };
